const statusMapping: Record<number, string> = {
  1: 'PENDING',
  3: 'SUSPENDED',
  4: 'DELETED',
  5: 'CONFIRMED',
  6: 'DRAFT',
  7: 'ARCHIVED',
  8: 'SHORTLISTED',
  9: 'INTERVIEWED',
  10: 'CONTACTED',
  11: 'SCREENED',
  12: 'DECLINED',
  13: 'VIEWED',
  14: 'APPROVED',
  15: 'REJECTED',
  16: 'ACTIVE',
  17: 'INACTIVE',
  18: 'PAID',
  19: 'FAILED',
  20: 'ONHOLD',
  21: 'CLOSED',
  22: 'SENT',
  23: 'OUTBOX',
  24: 'INBOX',
  25: 'REPLY',
  26: 'REVIEW',
  27: 'BEING_POSTED',
  28: 'POSTED',
  29: 'CONSIDERING',
  30: 'OFFER_MADE',
  31: 'HIRED',
  32: 'INTERVIEW_REQUESTED',
  33: 'INTERVIEW_BOOKED',
  34: 'BEHAVIOURAL_REQUESTED',
  35: 'FREE',
  36: 'CANCELLED',
  37: 'VIDEO_PROFILE_REQUEST',
  38: 'PUBLISHED',
  39: 'AGENCY_EXTERNAL_INVITATION',
  40: 'NEW',
  41: 'AWAITING_FEEDBACK',
  42: 'CLIENT_CONFIRMED',
  43: 'IN_REVIEW',
  44: 'GDPR_DELETED',
  45: 'APPLICATION_FORM_COMPLETED',
  46: 'BEHAVIOURAL_REPORT_COMPLETED',
  47: 'INTERVIEW_COMPLETED',
  51: 'GDPR',
  52: 'JOB_TEMPLATE',
  53: 'PARSED',
  54: 'CANDIDATE_DATABASE',
  55: 'COMPLETED',
  56: 'PROCESSING',
  57: 'ONLINE_INTERVIEW',
  58: 'MERGED',
  59: 'SENT_TO_ONBOARDING',
  60: 'ONBOARDING_COMPLETED',
  61: 'OFFER_DECLINED',
  62: 'PROSPECT',
  63: 'EXPIRED',
  64: 'PARTIALLY_COMPLETED',
  101: 'SCHEDULED',
  102: 'PARTIALLY_LIVE',
  103: 'REVERTED',
  104: 'COPY_WRITING',
  105: 'ATTENDED',
  106: 'ABSENT',
  107: 'ACCEPTED',
};

export const statusColorMapping: Record<string, string> = {
  PUBLISHED: "#009828",
  STANDARD: "#009828",
  SYSTEM: "#009828",
  COMPLETED: "#009828",
  DEFAULT: "#8F0000",
  PROCESSING: "#6699CC",
  ACTIVE: "#009828",
};


export const getStatusLabel = (status: number): string =>
  statusMapping[status] ?? 'UNKNOWN';

